const STORAGE_KEY = 'ez-active-nav-app'

export type ActiveNavApp = 'ezturn' | 'manage'

export const getActiveNavApp = (): ActiveNavApp | null => {
    try {
        const value = sessionStorage.getItem(STORAGE_KEY)
        if (value === 'ezturn' || value === 'manage') {
            return value
        }
    } catch {
        // ignore storage errors
    }
    return null
}

export const setActiveNavApp = (app: ActiveNavApp) => {
    try {
        sessionStorage.setItem(STORAGE_KEY, app)
    } catch {
        // ignore storage errors
    }
}
